import React, { useState, useEffect, useContext } from "react";
import {
  Button,
  Tooltip,
  IconButton,
  useTheme,
  useMediaQuery,
  Card,
  CardContent,
  CardActions,
  Typography,
  Divider,
  Skeleton,
  Box,
   Menu,
  MenuItem,
} from "@mui/material";
import dayjs from "dayjs";
import { DateRangeOptions } from "../Utility/Constants";
import DateRangeDialog from "../Appointments/ChangeDates";
import { DataGrid } from "@mui/x-data-grid";
import { useSnackbar } from "../Utility/UserMessageContext";
import Grid2 from "@mui/material/Grid2";
import EditIcon from "@mui/icons-material/Edit";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { fetchBillingDetails } from "../API/BillingApi";
import AuthContext from "../Context/AuthProvider";
import { removeBill } from "../API/BillingApi";
import MenuBar from "../common/MenuBar";
import "../common/styles/CommonStyles.css"; // Import your custom styles
import ConfirmationDialog from "../common/ConfirmationDialog";
import MoreVert from '@mui/icons-material/MoreVert';
import ListItemIcon from '@mui/material/ListItemIcon';
import { convertUTCToTimeZoneDateString } from "../Utility/DateTimeUtility";



const BillList = ({
  onNewBill,
  onEditDetails,
  onDelete,
  onViewPatientDetails,
}) => {
  const { auth } = useContext(AuthContext);
  const [rows, setRows] = useState([]);
  const [openDateRangeDialog, setOpenDateRangeDialog] = useState(false);
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteId, setdeleteId] = useState(null);

  const [loading, setLoading] = useState(false);
  const { showSnackbar } = useSnackbar();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm")); // Check if screen is small (mobile)
  const [filters, setFilters] = useState({
    from: dayjs(new Date()),
    to: dayjs(new Date()).add(7, "days"),
    selectedDateRangeOption: DateRangeOptions.Next7Days,
  });
  const [actionsMenuAnchor, setActionsMenuAnchor] = useState(null);
const [currentRow, setCurrentRow] = useState(null);

// Add menu handler functions (add after the existing functions)
const handleActionsMenuOpen = (event, row) => {
  setActionsMenuAnchor(event.currentTarget);
  setCurrentRow(row);
};

const handleMenuClose = () => {
  setActionsMenuAnchor(null);
  setCurrentRow(null);
};
  // const loadBillingData = async () => {
  //   setLoading(true);
  //   const facilityId = auth.selectedFacility.id;

  //   // Use filters instead of hardcoded dates
  //   const fromDate = filters.from.format("YYYY-MM-DD");
  //   const toDate = filters.to.format("YYYY-MM-DD");

  //   const response = await fetchBillingDetails(
  //     auth,
  //     facilityId,
  //     fromDate,
  //     toDate
  //   );

  //   if (response.isSuccess && Array.isArray(response.data)) {
  //     setRows(
  //       response.data.map((bill) => ({
  //         id: bill.id || bill.billNo,
  //         billNo: bill.displayId || "N/A",
  //         visitId: bill?.visit?.displayId || "N/A",
  //         planId: bill?.visit?.planId || "N/A",
  //         patientName:
  //           (bill.visit && `${bill.visit?.patientFirstName || ""} ${
  //             bill.visit?.patientLastName || ""
  //           }`.trim()) ||
  //           (bill.plan && `${bill.plan?.patientFirstName || ""} ${bill.plan?.patientLastName || ""}`.trim()) ||
  //           "N/A",
  //         billStatus: bill.status || "N/A",
  //         generatedBy: bill.createdByUserName || "N/A",
  //         createdDate: bill.billDate
  //           ? new Date(bill.billDate)
  //               .toLocaleDateString("en-GB", {
  //                 day: "2-digit",
  //                 month: "short",
  //                 year: "numeric",
  //               })
  //               .replace(/,/g, "")
  //               .toUpperCase()
  //           : "N/A",
  //         totalAmount: bill.totalAmount ?? 0,
  //         totalPayment: bill.paidAmount ?? 0,
  //         totalBalance: bill.balanceAmount ?? 0,
  //       }))
  //     );
  //   } else {
  //     console.error("Failed to fetch billing data:", response.data);
  //     setRows([]);
  //   }

  //   setLoading(false);
  // };
 const loadBillingData = async () => {
  setLoading(true);
  const facilityId = auth.selectedFacility.id;
  const fromDate = filters.from.format("YYYY-MM-DD");
  const toDate = filters.to.format("YYYY-MM-DD");

  const response = await fetchBillingDetails(
    auth,
    facilityId,
    fromDate,
    toDate
  );

  if (response.isSuccess && Array.isArray(response.data)) {
    setRows(
      response.data.map((bill) => ({
        id: bill.id || bill.billNo,
        billNo: bill.displayId || "N/A",
        visitId: bill?.visit?.displayId || "N/A",
        planId: bill?.visit?.planId || "N/A",
        patientId: bill.visit?.patientId || bill.plan?.patientId || null,
        patientName:
          (bill.visit &&
            `${bill.visit?.patientFirstName || ""} ${
              bill.visit?.patientLastName || ""
            }`.trim()) ||
          (bill.plan &&
            `${bill.plan?.patientFirstName || ""} ${
              bill.plan?.patientLastName || ""
            }`.trim()) ||
          "N/A",
        billStatus: bill.status || "N/A",
        generatedBy: bill.createdByUserName || "N/A",
        createdDate: bill.billDate || null, // Store the raw date
        totalAmount: bill.totalAmount ?? 0,
        totalPayment: bill.paidAmount ?? 0,
        totalBalance: bill.balanceAmount ?? 0,
      }))
    );
  } else {
    console.error("Failed to fetch billing data:", response.data);
    setRows([]);
  }

  setLoading(false);
};

  const handleDeleteBill = (billId) => {
    setdeleteId(billId);
    setOpenDeleteDialog(true);
  };

  const confirmDelete = async () => {
    if (!deleteId) return;

    setLoading(true);

    const response = await removeBill(auth, deleteId);
    if (response.isSuccess) {
      showSnackbar("✅ Bill deleted successfully!", "success");
      loadBillingData(); // Refresh the list
    } else {
      showSnackbar(response.data || "❌ Failed to delete bill", "error");
    }
    setLoading(true);
    setOpenDeleteDialog(false);
    setdeleteId(null);
  };
  useEffect(() => {
    loadBillingData();
  }, [auth.selectedFacility?.id, filters]);

  const columns = [
     {
    field: "billNo",
    headerName: "Bill",
    width: 200,
    renderCell: (params) => (
      <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
        <span
          style={{
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={() => onEditDetails(params.row)}
        >
          {params.row.billNo}
        </span>
        
        {/* Three dots menu */}
        <Tooltip title="Actions" arrow>
          <IconButton
            size="small"
            onClick={(event) => handleActionsMenuOpen(event, params.row)}
          >
            <MoreVert fontSize="small" />
          </IconButton>
        </Tooltip>
      </Box>
    ),
  },
    {
      field: "patientName",
      headerName: "Patient Name",
      width: 200,
      renderCell: (params) => (
        <span
          style={{
            textDecoration: "underline",
            cursor: "pointer",
          }}
          onClick={() => {
            const patientData = {
              id: params.row.patientId,
              firstName: params.row.patientName.split(" ")[0],
              lastName: params.row.patientName.split(" ").slice(1).join(" "),
            };
            onViewPatientDetails && onViewPatientDetails(patientData);
          }}
        >
          {params.row.patientName}
        </span>
      ),
    },
    { field: "billStatus", headerName: "Bill Status", width: 150 },
    { field: "generatedBy", headerName: "Generated By", width: 200 },
   { 
    field: "createdDate", 
    headerName: "Created Date", 
    width: 150,
    renderCell: (params) => (
      <div>
        {params.row.createdDate &&
          convertUTCToTimeZoneDateString(
            params.row.createdDate,
            auth?.selectedFacility?.timeZone
          )}
      </div>
    ),
  },
    {
      field: "totalAmount",
      headerName: "Total Amount",
       align: 'right',
       headerAlign: 'right',
      width: 120,
      renderCell: (params) => {
        const amount = Number(params.row.totalAmount || 0);
        return `Rs ${amount.toFixed(2)}`;
      },
    },
    {
      field: "totalPayment",
      headerName: "Total Payment",
      width: 120,
       align: 'right',
        headerAlign: 'right',
      renderCell: (params) => {
        const row = params.row;
        if (row?.id === "TOTAL") {
          return <strong>Rs {row.totalPayment}</strong>;
        }
        const payment = Number(row.totalPayment || 0);
        return `Rs ${payment.toFixed(2)}`;
      },
    },
    {
      field: "totalBalance",
      headerName: "Total Balance",
       align: 'right',
  headerAlign: 'right',
      width: 120,
      renderCell: (params) => {
        const row = params.row;
        if (row?.id === "TOTAL") {
          return <strong>Rs {row.totalBalance}</strong>;
        }
        const balance = Number(row.totalBalance || 0);
        return `Rs ${balance.toFixed(2)}`;
      },
    },
    // {
    //   field: "actions",
    //   headerName: "Actions",
    //   width: 150,
    //   renderCell: (params) => (
    //     <>
    //       {/* <Tooltip title="Edit Details" arrow>
    //         <IconButton onClick={() => onEditDetails(params.row)}>
    //           <EditIcon fontSize="small" />
    //         </IconButton>
    //       </Tooltip> */}

    //       <Tooltip title="Remove Row" arrow>
    //         <IconButton onClick={() => handleDeleteBill(params.row.id)}>
    //           <DeleteOutlineIcon fontSize="small" />
    //         </IconButton>
    //       </Tooltip>
    //     </>
    //   ),
    // },
  ];

  const renderBillCards = () => {
    if (loading) {
      return (
        <Box sx={{ p: 1 }}>
          {Array.from(new Array(5)).map((_, index) => (
            <Card
              key={index}
              variant="outlined"
              sx={{ mb: 2, borderRadius: 2 }}
            >
              <CardContent>
                <Skeleton variant="text" width="60%" height={25} />
                <Divider sx={{ my: 1 }} />
                <Skeleton variant="text" width="80%" height={20} />
                <Skeleton variant="text" width="70%" height={20} />
                <Skeleton variant="text" width="90%" height={20} />
              </CardContent>
              <CardActions sx={{ justifyContent: "flex-end", px: 2, pb: 2 }}>
                <Skeleton
                  variant="rectangular"
                  width={80}
                  height={30}
                  sx={{ mr: 1 }}
                />
                <Skeleton variant="rectangular" width={80} height={30} />
              </CardActions>
            </Card>
          ))}
        </Box>
      );
    }

    if (!loading && rows.length === 0) {
      return (
        <Box sx={{ p: 2, textAlign: "center" }}>
          <Typography variant="h6" color="text.secondary">
            No recent bills to display.
          </Typography>
        </Box>
      );
    }

    return (
      <Box sx={{ px: 1, maxHeight: "calc(100vh - 180px)", overflowY: "auto" }}>
        {rows.map((bill) => (
          <Card
            key={bill.id}
            variant="outlined"
            sx={{ mb: 2, borderRadius: 2 }}
          >
            <CardContent>
              {/* Bill Number - Clickable */}
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <Typography variant="body2" sx={{ fontWeight: "bold", mr: 1 }}>
                  Bill:
                </Typography>
                <Typography
                  variant="h6"
                  sx={{
                    textDecoration: "underline",
                    cursor: "pointer",
                    color: "primary.main",
                  }}
                  onClick={() => onEditDetails(bill)}
                >
                  {bill.billNo}
                </Typography>
              </Box>

              <Divider sx={{ my: 1 }} />

              {/* Patient Name - Clickable */}
              <Box sx={{ display: "flex", alignItems: "center", mb: 1 }}>
                <Typography variant="body2" sx={{ mr: 1 }}>
                  Patient:
                </Typography>
                <Typography
                  variant="body2"
                  sx={{
                    textDecoration: "underline",
                    cursor: "pointer",
                    color: "primary.main",
                  }}
                  onClick={() => {
                    const patientData = {
                      id: bill.patientId,
                      firstName: bill.patientName.split(" ")[0],
                      lastName: bill.patientName.split(" ").slice(1).join(" "),
                    };
                    onViewPatientDetails && onViewPatientDetails(patientData);
                  }}
                >
                  {bill.patientName}
                </Typography>
              </Box>

              <Typography variant="body2" sx={{ mb: 0.5 }}>
                <strong>Status:</strong> {bill.billStatus}
              </Typography>
              <Typography variant="body2" sx={{ mb: 0.5 }}>
                <strong>Generated By:</strong> {bill.generatedBy}
              </Typography>
              <Typography variant="body2" sx={{ mb: 0.5 }}>
                <strong>Created Date:</strong> {bill.createdDate}
              </Typography>
              <Typography variant="body2" sx={{ mb: 0.5 }}>
                <strong>Total Amount:</strong> Rs{" "}
                {Number(bill.totalAmount).toFixed(2)}
              </Typography>
              <Typography variant="body2" sx={{ mb: 0.5 }}>
                <strong>Total Payment:</strong> Rs{" "}
                {Number(bill.totalPayment).toFixed(2)}
              </Typography>
              <Typography variant="body2">
                <strong>Total Balance:</strong> Rs{" "}
                {Number(bill.totalBalance).toFixed(2)}
              </Typography>
            </CardContent>

            <CardActions sx={{ justifyContent: "flex-end", px: 2, pb: 2 }}>
              {/* <Tooltip title="Edit Bill" arrow>
              <IconButton
                size="small"
                color="primary"
                onClick={() => onEditDetails(bill)}
              >
                <EditIcon fontSize="small" />
              </IconButton>
            </Tooltip> */}
              <Tooltip title="Delete Bill" arrow>
                <IconButton
                  size="small"
                  color="error"
                  onClick={() => handleDeleteBill(bill.id)}
                >
                  <DeleteOutlineIcon fontSize="small" />
                </IconButton>
              </Tooltip>
            </CardActions>
          </Card>
        ))}
      </Box>
    );
  };

  return (
    <Grid2 container spacing={2} size={12}>
      {/* New Bill Button */}

      <Grid2 size={12} container>
        <Grid2 size={12}>
          <MenuBar
            showChangeDate={true}
            onChangeDate={() => setOpenDateRangeDialog(true)}
            newLabel="New Bill"
            showNew={true}
            onNew={onNewBill}
          />
        </Grid2>
      </Grid2>

      {/* Conditional Rendering: DataGrid for desktop, Cards for mobile */}
      <Typography variant="body1" sx={{ margin: "-10px 5px" }}>
        Showing bills from {filters?.from?.format("DD/MM/YYYY")} to{" "}
        {filters?.to?.format("DD/MM/YYYY")}
      </Typography>
      <Grid2
        item
        size={12}
        sx={{ maxHeight: "calc(100vh - 180px)", overflowY: "auto" }}
      >
        {isMobile ? (
          renderBillCards()
        ) : (
          <DataGrid
            localeText={{
              noRowsLabel:
                "There are no bill to display. Change the dates or create a new bill.",
            }}
            slotProps={{
              loadingOverlay: {
                variant: "skeleton",
                noRowsVariant: "skeleton",
              },
            }}
            initialState={{
              density: "compact",
              pagination: {
                paginationModel: { pageSize: 20 }, // Default page size
              },
            }}
            loading={loading}
            rows={rows} //filteredAppointments
            columns={columns}
            pageSizeOptions={[5, 10, 15,20]}
            rowsPerPageOptions={[5, 10, 15, 20]}
            sx={{
              margin: "0px 5px",
              "& .MuiTablePagination-toolbar": {
                minHeight: "unset",
                position: "sticky",
                alignItems: "center",
                paddingTop: "0 !important",
                paddingBottom: "0 !important",
                
              },
              "& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows":
                {
                  margin: 0,
                },
            }}
          />
        )}
      </Grid2>
      <DateRangeDialog
        key="bills"
        title="Show Bills For"
        filters={filters}
        setFilters={setFilters}
        openState={openDateRangeDialog}
        setOpenState={setOpenDateRangeDialog}
      />
      <Menu
  anchorEl={actionsMenuAnchor}
  open={Boolean(actionsMenuAnchor)}
  onClose={handleMenuClose}
>
  {currentRow && (
    <>
      <MenuItem
        onClick={() => {
          handleDeleteBill(currentRow.id);
          handleMenuClose();
        }}
      >
        <ListItemIcon>
          <DeleteOutlineIcon fontSize="small" />
        </ListItemIcon>
        Delete Bill
      </MenuItem>
    </>
  )}
</Menu>
      {/* delete Confirmation dialog */}
      <ConfirmationDialog
        title="Delete Bill"
        statement="Are you sure you want to delete this bill? This action cannot be undone."
          okButtonColor="error"
        open={openDeleteDialog}
        onClose={() => setOpenDeleteDialog(false)}
        onConfirm={confirmDelete}
      />
    </Grid2>
  );
};

export default BillList;
